import BasicButton from "../../components/Buttons/BasicButton";
import XsCont from "../../components/containers/Xs";
import BasicForm from "../../components/textField/BasicForm";
import { API_URL } from "../../consts/ApiUrl";
import { validationMessage } from "../../consts/ValidationMessage";
import {
  isValidMobilePhoneNumberPrefix,
  isValidPhoneNumberWithHyphen,
} from "../../utils/validationUtils";
import { Typography, Box } from "@mui/material";
import React, { FC, useState } from "react";
import { useNavigate } from "react-router-dom";
import parsePhoneNumber from 'libphonenumber-js';

type PhoneNumFormStepProps = {
  onNext: (requestId: string) => void;
};

const PhoneNumFormStep: FC<PhoneNumFormStepProps> = ({
  onNext,
}: PhoneNumFormStepProps) => {
  const [form, setForm] = useState({
    phoneNum: "",
  });
  const [errors, setErrors] = useState({
    phoneNum: "",
  });
  const navigate = useNavigate();
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    const newValue =
        (name === 'phoneNum' && !value.includes("-"))
      ? (parsePhoneNumber(value, "JP")?.formatNational() || value)
      : value;
    setForm((prev) => ({ ...prev, [name]: newValue }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validate: () => boolean = (): boolean => {
    const newErrors = { phoneNum: "" };
    let isValid: boolean = true;
    const phoneNum: string = form.phoneNum;

    if (phoneNum) {
      if (!isValidMobilePhoneNumberPrefix(phoneNum)) {
        newErrors.phoneNum = validationMessage.MOBILE_PHONE;
        isValid = false;
      }
      if (!isValidPhoneNumberWithHyphen(phoneNum)) {
        newErrors.phoneNum = validationMessage.MOBILE_PHONE_FORMAT;
        isValid = false;
      }
    } else {
      newErrors.phoneNum = `担当者携帯番号${validationMessage.REQUIRED}`;
      isValid = false;
    }
    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit: () => void = async (): Promise<void> => {
    if (!validate()) return;

    try {
      const response = await fetch(API_URL.VERIFY, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ mode: "send", phone_number: form.phoneNum }),
      });
      if (!response.ok) {
        navigate("/error");
        return;
      }
      const data = await response.json();
      const requestId: string = data.request_id;
      const userDetailInfo = JSON.parse(
        sessionStorage.getItem("userDetailInfo") || "{}"
      );
      sessionStorage.setItem(
        "userDetailInfo",
        JSON.stringify({
          ...userDetailInfo,
          chargePhoneNumber: form.phoneNum,
        })
      );
      if (requestId) {
        onNext(requestId);
      } else {
        throw new Error("リクエストIDが取得できませんでした。");
      }
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
      navigate("/error");
    }
  };

  return (
    <XsCont>
      <Box mt={10} textAlign="center">
        <Typography variant="h5" gutterBottom>
          電話番号入力
        </Typography>
      </Box>
      <Box component="form" mt={10} display="flex" flexDirection="column">
        <BasicForm
          label={"担当者携帯番号"}
          name={"phoneNum"}
          value={form.phoneNum}
          onChange={handleChange}
          error={!!errors.phoneNum}
          helperText={errors.phoneNum}
        />
        <Box mt={2}>
          <Typography variant="body2" color="textSecondary" gutterBottom>
            ※SMSのトライアルが必要な方は携帯電話番号以外ですとSMSの送信ができなくなってしまうため、携帯電話番号をご入力ください。
          </Typography>
        </Box>
        <BasicButton onClick={handleSubmit} mt={10}>
          認証コード送信
        </BasicButton>
      </Box>
    </XsCont>
  );
};

export default PhoneNumFormStep;
